import StencilHTMLElement from "./stencil-element";

class DebugDetails extends StencilHTMLElement {
  name = "DebugDetails";

  constructor() {
    super();
  }

  connectedCallback() {
    console.log(this.logPrefix, `Hello from DebugDetails`);
  }
}

export default DebugDetails;